<template>
  <b-container fluid style="margin: 50px;">
    <h1>Dados de usuário</h1>
    <b-row>
      <b-col md="2">
        <user-form :user="$store.state.user"></user-form>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col md="10">
        <h1>Dados de Terapeuta</h1>
        <therapist-form :therapistId="$store.state.user.therapist.id"/>
      </b-col>
    </b-row>
    
  </b-container>
</template>

<script>
import TherapistForm from '../components/TherapistForm.vue'
import UserForm from '../components/UserForm.vue'

export default {

  name: 'UserProfile',
  components: {
    TherapistForm,
    UserForm
  },  

}
</script>

<style>

</style>
